/* unplugin-vue-components disabled */import script from "./practice.vue?vue&type=script&setup=true&lang=js"
export * from "./practice.vue?vue&type=script&setup=true&lang=js"

import "./practice.vue?vue&type=style&index=0&id=36869aa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36869aa2"]])

export default __exports__